import React from "react";
import { DatePicker } from "@mui/x-date-pickers";
import moment from "moment";

type InputDatePickerProps = {
  formData: Record<string, string | undefined>;
  name: string;
  label: string;
  required?: boolean;
  margin?: "none" | "dense" | "normal";
  placeholder?: string;
  width?: number;
  [key: string]: unknown;
}

type InputDatePickerState = {
  selected: Date | null;
}

/**
 * Deprecated, use haven-design for new code
 * */
export class InputDatePicker extends React.Component<InputDatePickerProps, InputDatePickerState> {
  constructor (props: InputDatePickerProps) {
    super(props);
    const { formData, name } = this.props;
    if (!formData[name]) {
      this.state = { selected: null };
      return;
    }

    // Extract the year, month, and day to avoid converting a GMT Datetime to
    // the local time, potentially changing the date altogether.
    const datetime = formData[name] as string;
    const selected = moment.utc(datetime);
    this.state = {
      selected: new Date(selected.year(), selected.month(), selected.date()),
    };
  }

  value (): string {
    // checking for valid date prior to submitting:
    if (this.state.selected instanceof Date && !isNaN(this.state.selected.getTime())) {
      return this.state.selected.toISOString();
    }

    return "";
  }

  render () {
    const { name, label, required, margin } = this.props;
    return (
      <div className="form-group">
        <DatePicker
          slotProps={{
            textField: {
              id: name,
              style: { minWidth: "15em", margin: ".5em 0" },
              required: !!required,
              autoComplete: "off",
              variant: "outlined",
              margin: margin || "dense",
              label,
              name: "temp-input", // used to omit field when parsing form
            },
            inputAdornment: { position: "end" },
          }}
          disableFuture={label === "Date of Birth"}
          closeOnSelect
          format="MM/dd/yyyy"
          value={this.state.selected}
          onChange={(date: Date | null) => this.setState({ selected: date })}
        />
        <input readOnly type="hidden" name={name} value={this.value()} />
      </div>
    );
  }
}
